<script>
  import InfoBoxNumber from "./InfoBoxNumber.svelte";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let latitude;
  export let longitude;
  export let latLonDirection;

  const copyButtonClickHandler = () => {
    const message = latLonDirection
      ? `${latitude}, ${longitude}`
      : `${longitude}, ${latitude}`;
    navigator.clipboard.writeText(message);
    dispatch("textCopied", {
      text: message,
    });
  };

  const textCopiedClickHandler = (evt) => {
    dispatch("textCopied", {
      text: evt.detail.text,
    });
  };

  const swapButtonClickHandler = () => {
    dispatch("swapButtonClick");
  };
</script>

<div>
  <div class="latLonLine">
    <InfoBoxNumber
      number={latLonDirection ? latitude : longitude}
      on:textCopied={textCopiedClickHandler}
    />,
    <InfoBoxNumber
      number={latLonDirection ? longitude : latitude}
      on:textCopied={textCopiedClickHandler}
    />
    <button
      class="copyButton"
      on:click={copyButtonClickHandler}
      title="Copy to Clipboard">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-clipboard"
        ><path
          d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
        /><rect x="8" y="2" width="8" height="4" rx="1" ry="1" /></svg
      >
    </button>
  </div>
  {#if latLonDirection}
    (latitude, longitude)
  {:else}
    (longitude, latitude)
  {/if}
  &nbsp;<button
    class="swapButton"
    on:click={swapButtonClickHandler}
    title="Swap">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-repeat"
      ><polyline points="17 1 21 5 17 9" /><path
        d="M3 11V9a4 4 0 0 1 4-4h14"
      /><polyline points="7 23 3 19 7 15" /><path
        d="M21 13v2a4 4 0 0 1-4 4H3"
      /></svg
    >
  </button>
</div>

<style>
  div {
    text-align: center;
  }
  .latLonLine {
    font-family: monospace;
    font-size: 18px;
  }
  button {
    font-size: 10px;
    background: none;
    margin: 0;
    padding: 0;
    border: none;
    cursor: pointer;
    border-color: transparent;
    outline: none;
  }
  .copyButton {
    margin-left: 5px;
  }
</style>
